import { navbarStore } from './store/navbar-store';
import Vuex from 'vuex';
import VueI18n, { DateTimeFormats } from 'vue-i18n';
import DsFormatter from './formatter';
import { setupAxiosInterceptors } from '@/shared/config/axios-interceptor';

import VueCookie from 'vue-cookie';
import Vuelidate from 'vuelidate';
import Vue2Filters from 'vue2-filters';

import * as filters from '@/shared/filters/filters';
import { accountStore } from '@/shared/config/store/account-store';
import { translationStore } from '@/shared/config/store/translation-store';
import { axiosRequestLoader } from '@/shared/config/loader-interceptors';
import { loaderStore } from '@/shared/config/store/loader-store';
import { groupsManagerStore } from '@/shared/config/store/groups-manager-store';
import { askGooverStore } from '@/shared/config/store/ask-goover.store';
import { insightStore } from '@/shared/config/store/insight-store';
import { mapStore } from './store/map-store';
import { notificationViewStateStore } from './store/notification-view-state-store';
import { interactionStore } from '@/shared/config/store/interaction-store';
import { isJwtExpired } from 'jwt-check-expiration/src/index';
import { cardStore } from '@/shared/config/store/card-store';
import { appStore } from '@/shared/config/store/app-store';
import { briefingStore } from '@/shared/config/store/briefing-store';
import { userSettingStore } from '@/shared/config/store/user-setting-store';
import { discoveryReview } from '@/shared/config/store/discovery-review-store';
import { listCollection } from '@/shared/config/store/list-collection-store';

const dateTimeFormats: DateTimeFormats = {
  en: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    },
    medium: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
      hour: 'numeric',
      minute: 'numeric',
    },
  },
  ko: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    },
    medium: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
      hour: 'numeric',
      minute: 'numeric',
    },
  },
  // jhipster-needle-i18n-language-date-time-format - JHipster will add/remove format options in this object
};

export function initVueApp(vue) {
  vue.use(VueCookie);
  vue.use(Vuelidate);
  vue.use(Vue2Filters);
  setupAxiosInterceptors(() => {
    const token = sessionStorage.getItem('ds-authenticationToken') || localStorage.getItem('ds-authenticationToken');
    if (token) {
      if (isJwtExpired(token)) {
        history.replaceState({}, document.title, location.href.substr(0, location.href.length - location.hash.length));
        document.location.href = '/login';
      }
    }
  });
  axiosRequestLoader(initVueXStore(vue));
  filters.initFilters();
}

export function initI18N(vue) {
  vue.use(VueI18n);
  return new VueI18n({
    dateTimeFormats,
    silentTranslationWarn: true,
    formatter: new DsFormatter(),
    locale: localStorage.getItem('currentLanguage') as string | 'en',
    fallbackLocale: 'en',
  });
}

export function initVueXStore(vue) {
  vue.use(Vuex);
  return new Vuex.Store({
    modules: {
      accountStore,
      translationStore,
      loaderStore,
      interactionStore,
      userSettingStore,
      groupsManagerStore,
      mapStore,
      notificationViewStateStore,
      briefingStore,
      cardStore,
      appStore,
      navbarStore,
      discoveryReview,
      listCollection,
      askGooverStore,
      insightStore,
    },
  });
}
